module.exports = __webpack_public_path__ + "static/media/home_white.376754ea.png";